import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ILegalPageListItem, LegalPageKey, LegalPageLanguageType } from "../../models/LegalPage";
import { LegalPageService } from "../../services/legal-page.service";

export const useGetAllLegalPagesQuery = () => {
  return useQuery<ILegalPageListItem[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_LEGAL_PAGES],
    queryFn: () => LegalPageService.getAll().then((res) => res.data),
  });
};

export const useGetLegalPageContentQuery = (key: LegalPageKey, language: LegalPageLanguageType) => {
  return useQuery<string | null, Error>({
    queryKey: [QUERY_CONSTANTS.GET_LEGAL_PAGE_CONTENT, key, language],
    queryFn: () => LegalPageService.getContent(key, language).then((res) => res.data.content),
  });
};
